import React, { useState } from 'react';
import home from '../../assets/img/feed-imgs/left/home.svg';
import live from '../../assets/img/feed-imgs/left/live-streaming.svg';
import clips from '../../assets/img/feed-imgs/left/play.svg';
import shop from '../../assets/img/feed-imgs/left/shop.svg';
import gigs from '../../assets/img/feed-imgs/left/gigs.svg';
import blogs from '../../assets/img/feed-imgs/left/blog.svg';
import forum from '../../assets/img/feed-imgs/left/forum.svg';
import groups from '../../assets/img/feed-imgs/left/groups.svg';
import events from '../../assets/img/feed-imgs/left/events.svg';
import fundraisers from '../../assets/img/feed-imgs/left/fundraisers.svg';
import dating from '../../assets/img/feed-imgs/left/dating.svg';
import starIcon from '../../assets/img/feed-imgs/left/star.svg';
import { Link } from 'react-router-dom';
import './LeftSitebarMenu.css'
const LeftSitebarMenu = () => {
    const [links] = useState([
        {name: "Home", image: home, to: "/"},
        {name: "Live", image: live, to: "/live"},
        {name: "Clips", image: clips, to: "/clips"},
        {name: "Shop", image: shop, to: "/shop"},
        {name: "Gigs", image: gigs, to: "/gigs"},
        {name: "Blogs", image: blogs, to: "/blogs"},
        {name: "Forum", image: forum, to: "/forum"},
        {name: "Groups", image: groups, to: "/group"},
        {name: "Events", image: events, to: "/events"},
        {name: "Fundraisers", image: fundraisers, to: "/fundraisers"},
        {name: "Dating", image: dating, to: "/dating"}
    ])
    return (
        <div className='left-site-menu'>
            
            {
                links.map( (items, index) => {
                    return  <div className='d-flex align-center mb-lg-1  mb-xx-3 custom-border-menu-items' key={index}>
                            <div className='menu-items-background d-flex justify-content-start align-items-center'>
                                    <img className="me-3" src={items.image} alt="" />
                                <Link to={items.to} >{items.name}</Link>
                            </div>
                        </div>                         
                    })
            }
             <button className="mb-lg-0 mb-4" type="button" style={{height: "50px", backgroundColor: "#FFFFFF11",borderRadius: "10px",borderStyle: "none", width: "100%"}}><img src={starIcon} alt="" /></button>
             
        </div>
    );
};

export default LeftSitebarMenu;